import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaId: 0,

    /* Registro */
    tarjetasPlasticos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, tarjetaId) {
        state.tarjetaId = tarjetaId;
        state.tarjetasPlasticos = [];
    },
    'INICIALIZAR_TARJETAS_PLASTICOS'(state) {
        state.tarjetasPlasticos = [];
    },
    'SET_TARJETAS_PLASTICOS'(state, tarjetasPlasticos) {
        state.tarjetasPlasticos = tarjetasPlasticos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(tarjeta => tarjeta.nombre.toUpperCase().trim());
    },
};

const actions = {
    inicializar: ( { commit }, tarjetaId) => {
        return new Promise((resolve, reject) => {
                commit('INICIALIZAR', tarjetaId)
                resolve();
            }, error => {
                reject(error);
            })
    },
    getTarjetasPlasticos: ({ commit, state }) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETAS_PLASTICOS')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            apiAxios.get('tarjetas-plasticos/tarjeta/' + state.tarjetaId + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_TARJETAS_PLASTICOS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
    getList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST')

            apiAxios.get('tarjetas-plasticos/list')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        })
    },
};

const getters = {
    getField,

    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}